export default __webpack_public_path__ + "static/media/SCENE1v4.c63df042.svg";